<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <h1 class="page-title pull-left">No Spray</h1>
        <div class="pull-right">
          <button class="pointer btn btn-lg btn-primary" v-on:click="form.showEdit({})">Create New</button>
        </div>
      </div>
    </div>

    <div class="panel">
      <search-fields :form="form" :fields="searchFieldsList"></search-fields>

      <loading :working="form.working()"></loading>

      <div class="panel-body" v-if="!form.working()">
        <div class="col-xs-12 table-responsive">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Active</th>
                <th>Contract</th>
                <th>Zone</th>
                <th>Address</th>
                <th>Contact</th>
                <th>Coordinates</th>
                <th>Date</th>
                <th width="120"></th>
              </tr>
            </thead>
            <tbody>

            <tr v-for="item in form.list">
              <td><i class="fa" :class="{ 'fa-check-square-o': item.attributes.isActive, 'fa-square-o': !item.attributes.isActive}"></i></td>
              <td>{{ contractName(item.attributes.contractId) }}</td>
              <td>{{ zoneName(item.attributes.zoneId) }}</td>
              <td class="pointer" v-on:click="showMap(`${item.attributes.address}, ${item.attributes.city} ${stateName(item.attributes.stateId)} ${item.attributes.zip} `)">
                <i class="fa fa-map"></i>
                {{ item.attributes.address }}<br>
                {{ item.attributes.city }}, {{ stateName(item.attributes.stateId) }} {{ item.attributes.zip }}
              </td>
              <td>
                {{ item.attributes.firstName }} {{ item.attributes.lastName}}<br>
                {{ item.attributes.email }}<br>
                {{ item.attributes.phone }}
              </td>
              <td class="pointer" v-on:click="showMap({lat: item.attributes.latitude, lon: item.attributes.longitude})">
                <i class="fa fa-map"></i> {{ item.attributes.latitude }}, {{ item.attributes.longitude }}
              </td>
              <td>{{ item.attributes.createdAt | date }}</td>
              <td>
                <!--<a class="pointer text-primary" v-on:click="form.showEdit({id: item.id})"><i class="fa fa-pencil" style="margin-right: 10px;"></i></a>-->
                <router-link :to="{ name: 'data-no-spray-details', params: { id: item.id }}"><i class="fa fa-ellipsis-h" style="margin-right: 10px;"></i></router-link>
                <a class="pointer text-danger" v-on:click="form.destroy(item.id)"><i class="fa fa-times"></i></a>
              </td>
            </tr>


            </tbody>
            <pager :form="form"></pager>

          </table>
        </div>
      </div>
    </div>

    <site-form :form="form"></site-form>
    <google-map ref="gmap"></google-map>

  </div>
</template>

<script>
  import NoSprayService from '@/services/NoSprayService';
  import Form from '@/utils/form';
  import loader from '@/utils/loader';
  import siteForm from '@/components/forms/no_spray';
  import pager from '@/components/forms/pager';
  import googleMap from '@/components/googleMap';
  import loading from '@/components/loading';
  import searchFields from '@/components/search_fields';
  import store from '@/store';

  export default {
    name: 'no_spray',

    props: ['id', 'type'],

    components: {
      pager,
      siteForm,
      googleMap,
      loading,
      searchFields
    },

    data() {
      return {
        searchFieldsList: {'name': 'Contact Name', 'address': 'Address', 'zone': 'Zone'},
        form: new Form(
          NoSprayService,
          {

          })
      }
    },

    created() {
      if (this.$props.id == 'new') {
        window.bus.$on('item-created', () => {
          if (this.$route.path.indexOf('no-spray') > -1) {
            setTimeout(() => {
              this.form.showEdit({ title: 'Enter No Spray Data'});
            }, 1000);
          }
        });
      }
    },

    methods: {
      contractName(id) {
        return this.$store.getters.contractNameById(id);
      },
      stateName(id) {
        return this.$store.getters.stateNameById(id);
      },
      zoneName(id) {
        return this.$store.getters.zoneNameById(id);
      },
      showMap(coordinates) {
        this.$refs.gmap.showMap(coordinates);
      }
    },

    mounted() {
      loader.lookups()
        .then(() => {
          this.form.getList();
        });

      if (this.$props.id) {
        switch (this.$props.type) {
          case 'create':
            break;
        }
        this.form.showEdit({ title: 'Enter No Spray Data' });
      }
    }

  }
</script>

<style lang="scss">

</style>